<app-spinner-overlay></app-spinner-overlay>

<div *ngIf="!loading && strutturaValidazione" class="contenuto">
  <app-anteprima-validazione-iro
    #validazione
    [questionarioValidazione]="strutturaValidazione"
    (completato)="salva($event)"
    [readOnly]="data.readOnly"
  ></app-anteprima-validazione-iro>
</div>

<div class="no-dati" *ngIf="!datiValidazione">
  <div class="no-dati">
    {{ erroreDatiValidazione }}
  </div>
</div>
